
import config from '@/assets/config.json';
import api from '../../api/index';
const state = {}
const mutations = {

}
const getters = {

}
const actions = {
  GroupList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/video/group/all`,{ params:opt},
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  AddGroupList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/video/group`,opt,
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  }, 
  DeteGroupList({
    rootState,
    commit
  }, id,opt) {
    return new Promise((resolve, reject) => {
      api.delete(`${config.newHttps.api}/merchant/video/group/${id}`,{params:opt}
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  EditGroupList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.put(`${config.newHttps.api}/merchant/video/group`,opt,
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  GetAutograph({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.UpVideo.api}/api/Uploads/checkAutograph`, opt,
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  Addification({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/video/material`, opt,
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  GetContentList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/video/material`,{params: opt}
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  capacity({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/video/capacity`,{
        params:opt
      }
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  Deteleitem({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.delete(`${config.newHttps.api}/merchant/video/material/${opt.id}?token=${opt.token}`
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  Editification({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      let data= opt.id
      Reflect.deleteProperty(opt,"id");
      api.put(`${config.newHttps.api}/merchant/video/material/${data}`,opt
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  Deletification({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      let data= opt.id
      Reflect.deleteProperty(opt,"id");
      api.put(`${config.newHttps.api}/merchant/video/material/${data}`,opt
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  shopListAct({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/video/goods`,{
        params:opt
      }
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  GetProvinceCityArea({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.logisticsHttps.api}/api/Dic/GetDistrictByParentCode`,{params:opt}
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  DetailContentItem({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/video/material/${opt.id}?token=${opt.token}`
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  Publishing({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      let data= opt.id
      Reflect.deleteProperty(opt,"id");
      api.put(`${config.newHttps.api}/merchant/video/release/${data}`,opt
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
